import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 transform hover:scale-105 shadow-md';
  const variants = {
    primary: 'bg-brand-sage hover:bg-brand-sageDark text-white px-8 py-4 text-lg md:text-xl',
    secondary: 'bg-brand-peach hover:bg-brand-peachDark text-white px-8 py-4 text-lg md:text-xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={classes} data-id="element-21">
        {children}
        <ArrowRight className="ml-2 w-5 h-5" data-id="element-22" />
      </a>;
  }
  return <button className={classes} {...props} data-id="element-23">
      {children}
      <ArrowRight className="ml-2 w-5 h-5" data-id="element-24" />
    </button>;
}